module.exports = __webpack_public_path__ + "static/media/PoweredByAceAge_240px.4234a836.png";